var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"pr-2",attrs:{"cols":"3"}},[_c('TableTrainings')],1),_c('v-col',{attrs:{"cols":"9"}},[_c('TrainingDetail')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }